import withProps from '../../utils/withProps';
import TestEditor from './editor';

export default withProps(TestEditor, {
    isNew: true,
    level: '',
    skill: '',
    testId: ''
});